import { CM_BRAND_BAR_BG, CM_EMBLEM_SRC, CM_FIRM_NAME_SRC } from '../../constants/brand'
import { cn } from '../../lib/utils'

type CmLawBrandBarProps = {
  className?: string
}

/** Site header: emblem (sidebar) + firm name wordmark SVG */
export function CmLawBrandBar({ className }: CmLawBrandBarProps) {
  return (
    <div
      className={cn('flex w-full items-center gap-3 px-4 py-4 sm:px-6', className)}
      style={{ backgroundColor: CM_BRAND_BAR_BG }}
    >
      <img
        src={CM_EMBLEM_SRC}
        alt=""
        className="h-10 w-10 flex-shrink-0 sm:h-11 sm:w-11"
        aria-hidden
      />
      <img
        src={CM_FIRM_NAME_SRC}
        alt="Castronovo & McKinney"
        className="h-7 w-auto max-w-[min(100%,20rem)] object-contain object-left brightness-0 invert sm:h-8"
      />
    </div>
  )
}
